import AttachmentIcon from "@mui/icons-material/Attachment";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

const StyledIcon = styled(IconButton)(() => ({
    marginLeft: "5px",
}));

const AttachmentsButton = ({ setOpen, toolTipText }) => {
    return (
        <Tooltip title={toolTipText}>
            <StyledIcon
                onClick={(event) => {
                    event.stopPropagation();
                    setOpen(true);
                }}
            >
                <AttachmentIcon />
            </StyledIcon>
        </Tooltip>
    );
};
AttachmentsButton.propTypes = {
    setOpen: PropTypes.func,
    toolTipText: PropTypes.string,
};
export default AttachmentsButton;
